export default {
  tabs: {
    profile: 'Profil',
    branding: 'Branding',
    domain: 'Domeniu',
    earning: 'Câștiguri',
    feature_flags: 'Indicatoare de funcționalitate',
    notification_channels: 'Canale de notificare',
    pricing: 'Prețuri',
    fees: 'Comisioane',
    payments: 'Plăți',
    billing: 'Facturare',
  },
  earning: {
    internal_notice: 'Setări exclusiv FoodAmigos. Nu sunt vizibile partenerului.',
    read_only_notice: 'Doar citire. Faceți clic pe Editați pentru a modifica.',
    editing_notice: 'Editare — modificările afectează calculele reale de plată.',
  },
  fees: {
    internal_notice:
      'Setări doar pentru FoodAmigos. Nu sunt vizibile partenerului, iar acest tab poate fi deschis doar de super administratori. Modificările afectează suma încasată de la clienți și veniturile platformei.',
    read_only_notice: 'Doar citire. Apasă Editare pentru a modifica orice valoare din acest tab.',
    editing_notice:
      'Editare — Salvare scrie atât taxa de serviciu, cât și tarifele de procesare. Tarifele se aplică de la următoarea taxă; tranzacțiile anterioare păstrează marja înregistrată pentru ele.',
  },
  profile: {
    read_only_notice: 'Doar citire. Faceți clic pe Editați pentru a modifica.',
    editing_notice: 'Editare — numele afișat este vizibil consumatorilor.',
    form: {
      name: {
        label: 'Numele partenerului',
        hint: 'Numele legal / al entității. Folosit intern și pe documentele de facturare.',
      },
      display_name: {
        label: 'Nume afișat consumatorilor',
        hint: 'Eticheta „Powered by ___" afișată clienților. Implicit, se folosește numele partenerului.',
      },
      admin_email: {
        label: 'E-mail administrator',
        hint: 'Contul de administrator invitat. Nu poate fi modificat aici — contactați echipa tehnică pentru a transfera contul.',
      },
      invoicing_emails: {
        label: 'E-mailuri pentru facturi',
        hint: 'Chitanțele pentru facturile emise pe numele acestui partener sunt trimise la fiecare dintre aceste adrese. Lăsați gol pentru a folosi e-mailul administratorului.',
        placeholder: 'E-mail administrator',
      },
      status: {
        label: 'Stare',
        hint: 'Partenerii invitați devin activi la prima autentificare — activarea manuală omite acest pas. Suspendarea dezactivează toate autentificările echipei partenerului.',
      },
      region: {
        label: 'Regiune',
        hint: 'Țara este fixă. Alegeți un stat când restaurantele partenerului respectă reguli fiscale la nivel de stat — aceasta modifică doar valorile implicite ale partenerului, nu restaurantele existente.',
      },
      messenger_audience: {
        label: 'Chat de suport',
        hint: 'Cine din cadrul acestui partener are acces la chatul de suport FoodAmigos. Personalul FoodAmigos îl are mereu. Partenerii white-label își susțin propriile restaurante, așa că doar administratorii lor primesc acces.',
        options: {
          everyone: 'Toată lumea, inclusiv restaurantele',
          partner_admins: 'Doar administratorii partenerului',
          nobody: 'Nimeni',
        },
      },
      shop_domains: {
        label: 'Domenii magazin',
        hint: 'Domeniile rădăcină pe care sunt găzduite magazinele restaurantelor partenerului. Domeniul principal este folosit pentru brandurile noi. Partenerul își conectează și deconectează singur propriile domenii de magazin; fila Domeniu afișează înregistrările lor DNS.',
      },
    },
    region: {
      whole_country: 'Toată țara',
    },
    shop_domains: {
      primary: 'Principal',
      platform_default: 'Implicit platformă',
      empty: 'Niciun domeniu de magazin asociat încă',
    },
    statuses: {
      invited: 'Invitat',
      active: 'Activ',
      suspended: 'Suspendat',
    },
    custody: {
      label: 'Procesarea plăților',
      not_configured: 'Neconfigurat încă',
      provider: 'Gateway-ul propriu al partenerului',
      platform: 'FoodAmigos procesează plățile',
      bank_account: {
        set: 'Cont bancar: {{label}} ({{status}})',
        missing: 'Încă nu există cont bancar. Partenerul îl introduce la Facturare parteneri.',
        statuses: {
          active: 'activ',
          pending_verification: 'în verificare',
          action_needed: 'acțiune necesară',
          errored: 'plata a eșuat',
          missing: 'lipsă',
        },
      },
      hint: 'Decis de configurarea plăților din tab-ul Plăți și blocat odată ce un rail este salvat. Sub procesarea FoodAmigos, cota de venit a partenerului este plătită lunar.',
      kyc: {
        label: 'Cont de plată',
        missing: 'Neregistrat încă',
        incomplete: 'Verificare incompletă',
        complete: 'Gata pentru plăți',
        currently_due: 'Stripe mai are nevoie de: {{fields}}',
        send_link: 'Trimite link de onboarding',
        link_copied:
          'Linkul de onboarding a fost copiat în clipboard — trimite-l partenerului. Este de unică folosință și expiră.',
        link_ready: 'Link de onboarding — trimite-l partenerului (unică folosință, expiră)',
        link_failed: 'Linkul de onboarding nu a putut fi creat.',
      },
    },
    suspend_confirm: {
      title: 'Suspendați acest partener?',
      description:
        'Toți membrii echipei partenerului vor fi dezactivați și sesiunile lor revocate. Restaurantele lor rămân active.',
    },
  },
  branding: {
    read_only_notice: 'Doar citire. Faceți clic pe Editați pentru a modifica.',
    editing_notice: 'Editare — modificările sunt vizibile pe suprafețele white-label ale partenerului.',
    upload: 'Încărcați logo',
    logo: {
      label: 'Logo',
      hint: 'Afișat pe suprafețele white-label ale partenerului.',
    },
    circle_logo: {
      label: 'Favicon / logo circular',
      hint: 'Logo pătrat folosit ca favicon și avatar. Opțional — poate fi eliminat.',
    },
    splash_image: {
      label: 'Imagine autentificare',
      hint: 'Umple jumătatea stângă a paginii de autentificare white-label (decupare cover). Recomandat: portret, cel puțin 1200×1200px. Opțional — poate fi eliminat.',
    },
    footer_note: 'Mai multe opțiuni de branding (culori secundare) vor fi adăugate ulterior.',
  },
  revenue_split: {
    title: 'Împărțirea veniturilor',
    description:
      'Stabiliți cota partenerului din fiecare comision colectat de FoodAmigos pe comenzile restaurantelor. Implicit 0% — FoodAmigos păstrează comisionul integral până la acordarea unei cote. Plătit la fiecare ciclu de facturare.',
    manage_on_fees: 'Gestionați în fila Comisioane',
    split: 'Partener {{partner}}% · FoodAmigos {{platform}}%',
    rows: {
      processing: 'Comisioane de procesare',
      gift_card: 'Comision card cadou',
      delivery: 'Comisioane livrare',
      service_fee: 'Taxă de serviciu',
    },
    notes: {
      service_fee: 'Suma percepută clienților este setată în secțiunea Control comision de serviciu din tab-ul Taxe.',
    },
  },
  service_fee_controls: {
    title: 'Controale taxă de serviciu',
    description: 'Taxa de serviciu pe care partenerul o percepe clienților suplimentar față de comandă.',
    zero_percentage_warning:
      'Un procent de 0% nu dezactivează taxa de serviciu: taxele calculate sub suma minimă sunt rotunjite în sus, astfel că fiecare comandă este taxată cel puțin cu minimul.',
  },
  hard_limits: {
    title: 'Limite stricte',
    description:
      'Plafoane FoodAmigos aplicate la salvare și la finalizarea comenzii. Nicio taxă de serviciu pentru acest partener — inclusiv cele per restaurant — nu poate depăși aceste limite.',
    max_percentage: {
      label: 'Taxă de serviciu maximă %',
      help: 'Taxa de serviciu a partenerului nu poate depăși aceasta. Limita platformei: 5%.',
    },
    min_amount: {
      label: 'Sumă minimă taxă de serviciu',
      help: 'Minimele per restaurant nu pot fi setate sub această sumă.',
    },
    max_amount: {
      label: 'Sumă maximă taxă de serviciu',
      help: 'Plafon absolut al taxei de serviciu fixe, indiferent de procent.',
    },
  },
  form: {
    charges_service_fee_on_site: {
      label: 'Percepe taxa de serviciu la comenzile la masă',
      description:
        'Valoarea implicită pentru restaurantele acestui partener; fiecare o poate seta pe a sa. Dezactivat: comenzile la masă nu plătesc taxa de serviciu.',
    },
    is_service_fee_change_allowed: {
      label: 'Permiteți modificarea taxei de serviciu per restaurant',
      description: 'Permite restaurantelor individuale ale partenerului să folosească o taxă de serviciu diferită.',
    },
    service_fee_platform_share: {
      label: 'Cota Foodamigos din taxa de serviciu',
    },
    recommended: 'Recomandat: {{value}}',
    service_fee_percentage: {
      label: 'Procent implicit taxă de serviciu',
      help: 'Aplicat fiecărui restaurant al partenerului dacă nu este suprascris.',
    },
    min_service_fee_amount: {
      label: 'Sumă minimă implicită',
      help: 'Minim implicit per comandă — taxele calculate sub acesta sunt rotunjite în sus. Restaurantele pot seta propriile valori în limitele FoodAmigos.',
    },
    max_service_fee_amount: {
      label: 'Sumă maximă implicită',
      help: 'Plafon implicit per comandă — restaurantele pot seta propriile valori în limitele FoodAmigos.',
    },
    primary_color: {
      label: 'Culoare principală brand',
    },
    dashboard_subdomain: {
      label: 'Slug autentificare partener',
      hint: 'Slug cu litere mici — identifică marca partenerului în linkul de autentificare al echipei sale (?partner=…).',
      placeholder: 'partner-name',
    },
    login_url: {
      label: 'Link autentificare echipă',
      hint: 'Linkul pe care echipa partenerului îl folosește pentru a accesa pagina de autentificare a mărcii sale.',
    },
    file: {
      label: 'Imagine',
    },
  },
  buttons: {
    edit: 'Editați',
    cancel: 'Anulați',
    save: 'Salvați',
  },
  toasts: {
    load_error: 'Setările nu au putut fi încărcate.',
    failed_to_save_changes: 'Salvarea modificărilor a eșuat',
    changes_got_saved: 'Modificările au fost salvate',
    logo_uploaded: 'Logo încărcat',
    logo_upload_failed: 'Încărcarea logo-ului a eșuat',
    logo_removed: 'Logo eliminat',
    logo_remove_failed: 'Eliminarea logo-ului a eșuat',
    file_too_large: 'Fișierul este prea mare. Dimensiunea maximă este {{max}} MB.',
    image_too_narrow: 'Imaginea de autentificare trebuie să aibă cel puțin {{min}}px lățime.',
  },
  notification_channels: {
    master_locked:
      'Partenerul principal trimite pentru fiecare restaurant al platformei, deci canalele sale nu pot fi modificate aici.',
    unavailable: 'Canalele de notificare nu sunt încă disponibile pentru acest backend.',
    notice:
      'Setare internă. Un partener fără cont Twilio propriu trebuie să rămână doar pe email: altfel fiecare SMS, mesaj WhatsApp și apel vocal ar pleca de pe contul Twilio al FoodAmigos.',
    forbidden: 'Doar administratorii super pot schimba canalele de notificare.',
    columns: {
      channel: 'Canal',
      status: 'Activat',
    },
    channels: {
      email: {
        name: 'Email',
        description: 'Mereu activ, ca partenerul și restaurantele sale să poată fi contactați oricând.',
      },
      sms: {
        name: 'SMS',
        description: 'Actualizări de comandă și coduri de autentificare către clienți prin SMS.',
      },
      whatsapp: {
        name: 'WhatsApp',
        description: 'Alerte pentru proprietarii de restaurante și coduri de autentificare pentru clienți pe WhatsApp.',
      },
      voice_call: {
        name: 'Apeluri vocale',
        description: 'Apeluri de reamintire pentru comenzile în așteptare și preluare telefonică.',
      },
      push: {
        name: 'Notificări push',
        description:
          'Notificări push către clienți și către aplicația dashboard a proprietarului. Alertele pe tabletele personalului nu sunt afectate.',
      },
    },
    toasts: {
      load_error: 'Nu s-au putut încărca canalele de notificare.',
      error: 'Nu s-au putut salva canalele de notificare.',
      saved: 'Canalele de notificare au fost salvate.',
    },
  },
  feature_flags: {
    internal_notice: 'Setări exclusiv FoodAmigos. Invizibile pentru partener. Modificările intră în vigoare imediat.',
    read_only:
      'Doar citire — modificarea facturării restaurantelor necesită o lansare coordonată, nu un comutator. Contactați ingineria.',
    forbidden: 'Doar super adminii pot gestiona indicatoarele de funcționalitate ale partenerilor.',
    columns: {
      feature: 'Funcționalitate',
      status: 'Stare',
    },
    flags: {
      external_printer: {
        name: 'Imprimantă de bonuri externă',
        description:
          'Setarea implicită pentru restaurantele integrate de acest partener de acum înainte: fiecare restaurant nou poate conecta din start o imprimantă de bonuri în rețea la aplicația terminalului de comenzi. Restaurantele existente păstrează ce e setat în tab-ul lor Feature Flags, iar fiecare restaurant poate fi în continuare comutat individual acolo.',
      },
      plg_onboarding: {
        name: 'Onboarding self-serve (PLG)',
        description:
          'Onboarding self-service pentru parteneri: oferă acestui partener pagina ghidată „Restaurant nou” și expertul de onboarding în locul modalului clasic Adaugă companie și al stepper-ului Începe, ascunde pentru partener și restaurantele sale funcțiile exclusive FoodAmigos și cele încă neaplicabile și blochează prima lansare live până la stabilirea unei date de lansare. Activ pentru fiecare partener nou.',
      },
      issue_end_customer_receipts: {
        name: 'Facturi client final',
        description:
          'Permite oaspeților să solicite o factură la finalizarea comenzii și să o primească pe email. Dezactivat pentru partenerii noi; regulile internaționale de format al facturilor îl fac costisitor de susținut.',
      },
      merchant_billing: {
        name: 'Facturare restaurant',
        description:
          'Facturează restaurantele partenerului prin platformă. Dezactivat înseamnă că se reglează în afara acesteia.',
      },
      cuisine_backfill: {
        name: 'Completare automată bucătărie',
        description:
          'Permite rularea completării automate a tipului de bucătărie pentru restaurantele acestui partener.',
      },
      image_backfill: {
        name: 'Completare automată imagini',
        description:
          'Permite rularea completării automate a imaginilor de meniu pentru restaurantele acestui partener.',
      },
      auto_image_generation: {
        name: 'Generare automată imagini',
        description: 'Generează imagini de meniu la cerere pentru restaurantele acestui partener.',
      },
      provider_billing: {
        name: 'Facturare partener de către Foodamigos',
        description:
          'Include acest partener în ciclul de facturare Foodamigos. Dezactivat înseamnă că partenerul este facturat în afara platformei. De asemenea, activează PayPal (direct) pentru restaurantele acestui partener, cu taxa de serviciu percepută pe aceasta.',
      },
      partner_custom_dashboard_domain: {
        name: 'Domeniu propriu al panoului',
        description:
          'Permite acestui partener să conecteze un domeniu propriu pentru panou, astfel încât echipa și restaurantele sale să se autentifice sub adresa partenerului. Activarea sau dezactivarea modifică fiecare link de panou trimis de platformă pentru acest partener.',
      },
      partner_custom_shop_domain: {
        name: 'Domeniu de magazin propriu',
        description:
          'Permite acestui partener să conecteze un domeniu propriu pentru magazinele online ale restaurantelor sale, pe care fiecare restaurant primește propria adresă. Activați câte un partener pe rând: schimbă adresa pe care o folosesc clienții.',
      },
      partner_legal_documents: {
        name: 'Documente legale ale partenerului',
        description:
          'Generează notele legale, politica de confidențialitate și termenii pentru restaurantele acestui partener, pe baza datelor legale ale fiecărui restaurant. Dezactivat, sau cât timp datele unui restaurant sunt incomplete, restaurantele afișează documentele standard ale platformei.',
      },
    },
    toasts: {
      load_error: 'Eroare la încărcarea indicatoarelor de funcționalitate',
      error: 'Eroare la modificarea indicatorului de funcționalitate',
      enabled: 'Funcționalitate activată',
      disabled: 'Funcționalitate dezactivată',
    },
  },
};
